import React from 'react';

import {
  CART_LINE_EXTRAS_LABEL,
  CART_LINE_EXTRA_BY_REQUEST_SUFFIX,
} from '../../constants/byRequestCopy';
import { FILLS, FONTS } from '../../styles/tokens';
import { CartItemExtra } from '../../types';

interface CartLineExtrasProps {
  extras: CartItemExtra[];
}

/**
 * Renders a cart line's selected add-ons as a single muted line —
 * `Extras: <label> ×<qty>[ (by request)] · …` — directly under a cart
 * row's existing `meta` line. Kind-agnostic: it reads only `extras`, so it
 * renders identically for a package, service, or accommodation line.
 * Renders nothing for an empty array — the common case for a legacy line
 * or one that carries no modifier selection.
 */
const CartLineExtras: React.FC<CartLineExtrasProps> = ({ extras }) => {
  if (extras.length === 0) return null;

  const joined = extras
    .map(
      (extra) =>
        `${extra.label} ×${extra.quantity}${extra.is_by_request ? CART_LINE_EXTRA_BY_REQUEST_SUFFIX : ''}`,
    )
    .join(' · ');

  return (
    <p
      style={{
        fontFamily: FONTS.body,
        fontSize: '11px',
        color: FILLS.textMuted,
        margin: '0 0 4px',
      }}
    >
      {CART_LINE_EXTRAS_LABEL}: {joined}
    </p>
  );
};

export default CartLineExtras;
